<template>
  <div class="base-tabs">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'BaseTabs',
};
</script>

<style lang="scss" scoped>
.base-tabs {
  float: left;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0;
  background: #FFFFFF;
  border: 1px solid var(--solid-lavender-grey);
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.02);
  border-radius: 8px;
}
</style>
